import { createContext } from "react";

import { FramerateProfilesListingFilters } from "../listing/useFramerateProfilesListingFilters";
import { FramerateProfileListingItem } from "./FramerateProfilesListingItem";

interface IFramerateProfilesListingContext {
    allItems: FramerateProfileListingItem[];
    items: FramerateProfileListingItem[];
    isLoading: boolean;
    totalItems: number;
    add(item: FramerateProfileListingItem): void;
    update(item: FramerateProfileListingItem): void;
    load(filters: FramerateProfilesListingFilters): void;
}

export const FramerateProfileListingContext = createContext<IFramerateProfilesListingContext>(
    {} as IFramerateProfilesListingContext
);
